import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { MinusIcon, PlusIcon, XIcon, ShoppingBagIcon, TruckIcon, ShieldCheckIcon } from 'lucide-react';
// Sample cart items
const initialCartItems = [{
  id: '1',
  name: 'Elegant Rose Bouquet',
  price: 3500,
  image: 'https://images.unsplash.com/photo-1561181286-d3fee3785613?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  quantity: 1,
  color: 'Red',
  bouquetSize: 'Classic (12 stems)'
}, {
  id: '3',
  name: 'Sunshine Sunflower Arrangement',
  price: 4200,
  image: 'https://images.unsplash.com/photo-1593106410242-b3c438e8e012?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  quantity: 2,
  bouquetSize: 'Standard (10 stems)'
}, {
  id: 'featured-1',
  name: 'Premium Rose Collection',
  price: 5800,
  image: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  quantity: 1,
  color: 'Pink',
  bouquetSize: 'Deluxe (24 stems)',
  vase: 'Clear Glass Vase (+KES 1,500)'
}];
export function Cart() {
  const [cartItems, setCartItems] = useState(initialCartItems);
  const [couponCode, setCouponCode] = useState('');
  const [couponApplied, setCouponApplied] = useState(false);
  const updateQuantity = (id: string, newQuantity: number) => {
    if (newQuantity < 1) return;
    setCartItems(cartItems.map(item => item.id === id ? {
      ...item,
      quantity: newQuantity
    } : item));
  };
  const removeItem = (id: string) => {
    setCartItems(cartItems.filter(item => item.id !== id));
  };
  const applyCoupon = () => {
    if (couponCode.trim() !== '') {
      setCouponApplied(true);
    }
  };
  // Calculate subtotal
  const subtotal = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
  // Calculate additional costs
  const isShippingFree = subtotal >= 6000;
  const shipping = isShippingFree ? 0 : 350;
  const discount = couponApplied ? Math.round(subtotal * 0.1) : 0;
  const total = subtotal + shipping - discount;
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-481">
      <Header data-id="element-482" />
      <main className="flex-grow py-12" data-id="element-483">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-484">
          <h1 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-485">Your Cart</h1>
          {cartItems.length === 0 ? <div className="bg-white rounded-lg shadow-md p-8 text-center" data-id="element-486">
              <div className="flex justify-center mb-4" data-id="element-487">
                <ShoppingBagIcon className="h-16 w-16 text-gray-300" data-id="element-488" />
              </div>
              <h2 className="text-2xl font-medium text-gray-900 mb-2" data-id="element-489">
                Your cart is empty
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-490">
                Looks like you haven't added any items to your cart yet.
              </p>
              <Link to="/shop" className="inline-flex items-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-emerald-600 hover:bg-emerald-700" data-id="element-491">
                Continue Shopping
              </Link>
            </div> : <div className="lg:grid lg:grid-cols-12 lg:gap-8" data-id="element-492">
              <div className="lg:col-span-8" data-id="element-493">
                <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-494">
                  <ul className="divide-y divide-gray-200" data-id="element-495">
                    {cartItems.map(item => <li key={item.id} className="p-6 flex flex-col sm:flex-row" data-id="element-496">
                        <div className="flex-shrink-0 w-full sm:w-24 h-24 mb-4 sm:mb-0" data-id="element-497">
                          <img src={item.image} alt={item.name} className="w-full h-full object-cover object-center rounded-md" data-id="element-498" />
                        </div>
                        <div className="sm:ml-6 flex-1 flex flex-col" data-id="element-499">
                          <div className="flex justify-between" data-id="element-500">
                            <div data-id="element-501">
                              <h3 className="text-base font-medium text-gray-900" data-id="element-502">
                                <Link to={`/product/${item.id}`} data-id="element-503">
                                  {item.name}
                                </Link>
                              </h3>
                              <div className="mt-1 text-sm text-gray-500 space-y-1" data-id="element-504">
                                {item.color && <p data-id="element-505">Color: {item.color}</p>}
                                {item.bouquetSize && <p data-id="element-506">Size: {item.bouquetSize}</p>}
                                {item.vase && <p data-id="element-507">Vase: {item.vase}</p>}
                              </div>
                            </div>
                            <p className="text-base font-medium text-gray-900" data-id="element-508">
                              KES{' '}
                              {(item.price * item.quantity).toLocaleString()}
                            </p>
                          </div>
                          <div className="mt-4 flex justify-between items-center" data-id="element-509">
                            <div className="flex items-center border border-gray-300 rounded-md" data-id="element-510">
                              <button type="button" onClick={() => updateQuantity(item.id, item.quantity - 1)} className="p-2 text-gray-600 hover:text-gray-800" data-id="element-511">
                                <MinusIcon className="h-4 w-4" data-id="element-512" />
                              </button>
                              <span className="px-4 py-1 text-gray-900" data-id="element-513">
                                {item.quantity}
                              </span>
                              <button type="button" onClick={() => updateQuantity(item.id, item.quantity + 1)} className="p-2 text-gray-600 hover:text-gray-800" data-id="element-514">
                                <PlusIcon className="h-4 w-4" data-id="element-515" />
                              </button>
                            </div>
                            <button type="button" onClick={() => removeItem(item.id)} className="text-gray-500 hover:text-gray-700" data-id="element-516">
                              <XIcon className="h-5 w-5" data-id="element-517" />
                            </button>
                          </div>
                        </div>
                      </li>)}
                  </ul>
                </div>
                <div className="mt-6" data-id="element-518">
                  <Link to="/shop" className="text-emerald-600 hover:text-emerald-500 font-medium flex items-center" data-id="element-519">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-520">
                      <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" data-id="element-521" />
                    </svg>
                    Continue Shopping
                  </Link>
                </div>
              </div>
              <div className="lg:col-span-4 mt-8 lg:mt-0" data-id="element-522">
                <div className="bg-white rounded-lg shadow-md p-6" data-id="element-523">
                  <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-524">
                    Order Summary
                  </h2>
                  <div className="space-y-4 border-b border-gray-200 pb-4" data-id="element-525">
                    <div className="flex justify-between" data-id="element-526">
                      <p className="text-gray-600" data-id="element-527">Subtotal</p>
                      <p className="text-gray-900 font-medium" data-id="element-528">
                        KES {subtotal.toLocaleString()}
                      </p>
                    </div>
                    <div className="flex justify-between" data-id="element-529">
                      <p className="text-gray-600" data-id="element-530">Shipping</p>
                      {isShippingFree ? <p className="text-emerald-600 font-medium" data-id="element-531">Free</p> : <p className="text-gray-900 font-medium" data-id="element-532">
                          KES {shipping.toLocaleString()}
                        </p>}
                    </div>
                    {couponApplied && <div className="flex justify-between text-emerald-600" data-id="element-533">
                        <p data-id="element-534">Discount (10%)</p>
                        <p data-id="element-535">- KES {discount.toLocaleString()}</p>
                      </div>}
                  </div>
                  <div className="flex justify-between py-4 border-b border-gray-200" data-id="element-536">
                    <p className="text-lg font-medium text-gray-900" data-id="element-537">Total</p>
                    <p className="text-lg font-bold text-emerald-600" data-id="element-538">
                      KES {total.toLocaleString()}
                    </p>
                  </div>
                  <div className="mt-4" data-id="element-539">
                    <div className="flex space-x-2" data-id="element-540">
                      <input type="text" value={couponCode} onChange={e => setCouponCode(e.target.value)} placeholder="Coupon Code" className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-emerald-500 focus:border-emerald-500" data-id="element-541" />
                      <button type="button" onClick={applyCoupon} disabled={couponApplied} className={`px-4 py-2 text-sm font-medium rounded-md ${couponApplied ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-542">
                        Apply
                      </button>
                    </div>
                    {couponApplied && <p className="text-sm text-emerald-600 mt-2" data-id="element-543">
                        Coupon applied successfully!
                      </p>}
                  </div>
                  <div className="mt-6" data-id="element-544">
                    <Link to="/checkout" className="w-full bg-emerald-600 text-white py-3 px-4 rounded-md text-sm font-medium hover:bg-emerald-700 flex items-center justify-center" data-id="element-545">
                      Proceed to Checkout
                    </Link>
                  </div>
                  <div className="mt-6 space-y-4" data-id="element-546">
                    <div className="flex items-start" data-id="element-547">
                      <TruckIcon className="h-5 w-5 text-emerald-600 flex-shrink-0 mt-0.5 mr-2" data-id="element-548" />
                      <div data-id="element-549">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-550">
                          Free delivery in Nairobi
                        </h4>
                        <p className="mt-1 text-xs text-gray-500" data-id="element-551">
                          For orders above KES 6,000
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-552">
                      <ShieldCheckIcon className="h-5 w-5 text-emerald-600 flex-shrink-0 mt-0.5 mr-2" data-id="element-553" />
                      <div data-id="element-554">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-555">
                          Secure payment
                        </h4>
                        <p className="mt-1 text-xs text-gray-500" data-id="element-556">
                          We accept M-Pesa, Visa, and Mastercard
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </main>
      <Footer data-id="element-557" />
    </div>;
}